"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYPAL_INTERNATIONAL_FEE_MAX_AMOUNT = exports.PAYPAL_INTERNATIONAL_FEE_MIN_AMOUNT = exports.PAYPAL_INTERNATIONAL_FEE_PERCENTAGE = exports.PAYPAL_DOMESTIC_TRANSFERS_COUNTRIES = exports.ALLOWED_PAYPAL_WITHDRAW_REQUEST_COUNTRY_CODES = exports.MIN_WITHDRAW_PAYPAL_AMOUNTS = exports.MIN_WITHDRAW_CRYPTO_AMOUNTS = exports.MIN_WITHDRAW_CRYPTO_AMOUNT = void 0;
const enums_1 = require("../enums");
/*
 * @deprecated use MIN_WITHDRAW_CRYPTO_AMOUNTS instead.
 */
exports.MIN_WITHDRAW_CRYPTO_AMOUNT = 50;
exports.MIN_WITHDRAW_CRYPTO_AMOUNTS = {
    [enums_1.SystemCurrency.OKLP]: 50,
    [enums_1.SystemCurrency.USDT]: 1,
};
exports.MIN_WITHDRAW_PAYPAL_AMOUNTS = {
    [enums_1.SystemCurrency.USDT]: 10,
};
/*
 * @deprecated moved to env variable `PAYPAL_ALLOWED_WITHDRAW_REQUEST_COUNTRY_CODES`.
 */
exports.ALLOWED_PAYPAL_WITHDRAW_REQUEST_COUNTRY_CODES = ['US'];
exports.PAYPAL_DOMESTIC_TRANSFERS_COUNTRIES = ['US'];
exports.PAYPAL_INTERNATIONAL_FEE_PERCENTAGE = 5;
exports.PAYPAL_INTERNATIONAL_FEE_MIN_AMOUNT = 0.99;
exports.PAYPAL_INTERNATIONAL_FEE_MAX_AMOUNT = 4.99;
//# sourceMappingURL=withdrawal.js.map